__turbopack_context__.v({
  "buttons": "p7QAhW_buttons",
  "container": "p7QAhW_container",
  "content": "p7QAhW_content",
  "description": "p7QAhW_description",
  "emailText": "p7QAhW_emailText",
  "header": "p7QAhW_header",
  "iconTitle": "p7QAhW_iconTitle",
  "iconTitleWrap": "p7QAhW_iconTitleWrap",
  "title": "p7QAhW_title",
});
